
<div class="file-drop-area">
  <span class="fake-btn">Choose file</span>
  <span class="file-msg">{{file ? file.name : 'or drag and drop file here' }}</span>
  <input class="file-input" type="file">
</div>
<app-progress [progress]="progress"></app-progress>
<a (click)="clearInput()" style="color: #666666;">Clear Attachment</a>
<div></div>
